import {h} from 'ui/Framework';

export default h('svg', {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '11.241',
  height: '7.216',
  viewBox: '-1 -1 13 9'
}, [
  h('path', {
    d: 'M.13 5.3a.45.45 0 0 0 0 .634L1.29 7.085a.442.442 0 0 0 .628 0L5.62 3.381l3.704 3.704a.442.442 0 0 0 .628 0l1.158-1.15a.45.45 0 0 0 0-.635L5.934.13a.442.442 0 0 0-.627 0L.13 5.3z',
    fill: '#5b9fef'
  })
]);



// WEBPACK FOOTER //
// ./src/javascripts/svg/chevron-blue.es6.js